export default __webpack_public_path__ + "static/media/float.1afb338b.png";